import { forwardRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const TOOLBAR_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'blockquote'],
    ['clean'],
  ],
};

const FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'list',
  'link',
  'blockquote',
];

/**
 * Maps Quill's empty placeholder markup to an empty string so public
 * "no content" checks continue to work after save.
 */
export const normalizeEmptyHtml = (html) => {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const trimmed = html.trim();
  if (!trimmed) {
    return '';
  }

  const textOnly = trimmed
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .trim();

  if (!textOnly) {
    return '';
  }

  return html;
};

const RichTextEditor = forwardRef(({ value = '', onChange, placeholder }, ref) => {
  return (
    <div className="rich-text-editor [&_.ql-container]:min-h-[220px] [&_.ql-editor]:min-h-[220px] [&_.ql-toolbar]:rounded-t [&_.ql-container]:rounded-b [&_.ql-toolbar]:border-gray-300 [&_.ql-container]:border-gray-300">
      <ReactQuill
        ref={ref}
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={TOOLBAR_MODULES}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
});

RichTextEditor.displayName = 'RichTextEditor';

export default RichTextEditor;
